module.exports = __webpack_public_path__ + "static/media/D3.942cff10.mp3";